export const blockIconsHardwareWatchNew = (
	<span className='material-symbols-outlined'>watch</span>
);
